module.exports = __webpack_public_path__ + "static/media/logo_lamuse.cf2ed3f3.png";